module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/51b13a62d6d738aa73dc275e968af83b.png";